<div class="body-2 p-6 bg-primary text-primary-contrast">
  <p>{{ 'TODAY' | translate }}</p>
  <div class="display-1">{{ dayName }}</div>
  <div class="display-1">{{ date }}</div>
</div>

<mat-divider></mat-divider>

<!-- <div class="snapshot m-4">
  <mat-accordion>

    <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
      <mat-expansion-panel-header>
        <mat-panel-title fxLayoutAlign="start center">
          <b [class.text-hide]="collapsed" [class.text-show]="collapsed && collapsedOpen$ | async"
            class="mr-2">Snapshot</b>
          <div class="snapshot-count" fxLayoutAlign="center center">
            32
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="py-2" fxLayout="column" fxLayoutAlign="start start">
        <div fxLayout="row" class="w-full border-bottom py-2" *ngFor="let snapshots of snapshots; ">
          <p fxFlex="90%" [class.text-hide]="collapsed" [class.text-show]="collapsed && collapsedOpen$ | async">
            {{snapshots.text}}
          </p>
          <span fxFlex="10%" fxLayoutAlign="end center">{{snapshots.count}}</span>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div> -->

<mat-nav-list>
  <h3 matSubheader>{{ 'UPCOMING_EVENTS' | translate | uppercase }}</h3>
  <div class="content-section">
      <a [routerLink]="[]" mat-list-item *ngFor="let item of ScheduleData; ">
        <h4 matLine [innerHTML]="item.subject || 'No Subject'"></h4>
        <p matLine>{{ item.Start_time | date: 'medium' }}</p>
      </a>   
  </div> 

  <!-- <mat-divider></mat-divider> -->
  <!-- <h3 matSubheader>TODO-LIST</h3>
  <a [routerLink]="[]" mat-list-item>
    <h4 matLine>Invite Jack to play golf</h4>
    <p matLine>Added: 6 hours ago</p>
  </a>
  <a [routerLink]="[]" mat-list-item>
    <h4 matLine>Get to know Angular more</h4>
    <p matLine>Added: 2 days ago</p>
  </a>
  <a [routerLink]="[]" mat-list-item>
    <h4 matLine>Configure that new router</h4>
    <p matLine>Added: 5 days ago</p>
  </a>
  <mat-divider></mat-divider>
  <h3 matSubheader>SERVER STATISTICS</h3> -->
</mat-nav-list>

<!-- <div class="list-item" matRipple>
  <p>CPU Load (71% / 100%)</p>
  <p class="progress-bar">
    <mat-progress-bar color="primary" mode="determinate" value="71"></mat-progress-bar>
  </p>
</div>

<div class="list-item" matRipple>
  <p>RAM Usage (6,175 MB / 16,384 MB)</p>
  <p class="progress-bar">
    <mat-progress-bar color="accent" mode="determinate" value="34"></mat-progress-bar>
  </p>
</div>

<div class="list-item" matRipple>
  <p>CPU Temp (43° / 80°)</p>
  <p class="progress-bar">
    <mat-progress-bar color="warn" mode="determinate" value="54"></mat-progress-bar>
  </p>
</div>
<mat-divider></mat-divider> -->